import React from "react";
import { Link } from "react-router-dom";
import { getSiteBrand } from "@/lib/siteHosts";

const QuietFooter = () => (
  <footer className="cursor-footer" data-testid="quiet-footer">
    <div className="cursor-footer-inner">
      <p>{`© ${new Date().getFullYear()} ${getSiteBrand().name}`}</p>
      <div className="flex gap-4">
        <Link to="/terms">Terms of Service</Link>
        <Link to="/privacy-policy">Privacy Policy</Link>
        <Link to="/dpa">DPA</Link>
      </div>
    </div>
  </footer>
);

export default QuietFooter;
